// import React from 'react';
// import {
//   type EventTypes,
//   ListEventTypes,
// } from '@/domains/traffic-monitoring/constants/listEvent.constant';
// import { useColorStore } from '@/store/colorStore';

// interface RunningTextProps {
//   time: string;
//   eventTypes: EventTypes;
//   idPsc: string;
// }

// const RunningText = ({ time, idPsc, eventTypes }: RunningTextProps) => {
//   const { NEWCOLOR } = useColorStore();
//   const getEventType = ListEventTypes[eventTypes];

//   return (
//     <div className="w-full p-2 h-[70px] flex flex-row items-center gap-3 bg-white/10 backdrop-blur-xl border shadow-xl ">
//       <span className="title1medium">status Update: </span>
//       <span className="title1bold">{time}</span>
//       <span className="title1medium">Report</span>
//       <span className="title1bold">{idPsc}</span>
//       <span className="title1medium">is</span>
//       <span
//         className="w-fit p-2 rounded-full title2 uppercase text-white"
//         style={{ backgroundColor: NEWCOLOR[getEventType.color] }}
//       >
//         {getEventType.label}
//       </span>
//     </div>
//   );
// };

// export default RunningText;

import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  type AmbulanceTypes,
  type EventTypes,
  EventTypeTags,
  ListEventTypes,
  StatusAmbulance,
} from '@/domains/traffic-monitoring/constants/listEvent.constant';
import { useColorStore } from '@/store/colorStore';

// import './RunningText.css';

interface RunningTextProps {
  time: string;
  eventTypes: EventTypes;
  idPsc: string;
  // Set when the report's latest activity was an ambulance-side event (e.g.
  // a vehicle rejecting) rather than a report-level status change - the
  // report's own eventTypes can understate what just happened in that case
  // (a rejecting ambulance keeps the report "registered"), so this takes
  // over the badge to show what the ambulance actually did.
  ambulance?: { plateNumber: string; ambulanceType: AmbulanceTypes; statusLabel: string } | null;
  // No report to report on at all (e.g. an empty dashboard) - show a plain
  // placeholder instead of a badge for a report that doesn't exist.
  isEmpty?: boolean;
}

const RunningText = ({ time, idPsc, eventTypes, ambulance, isEmpty }: RunningTextProps) => {
  const { t } = useTranslation();
  const { NEWCOLOR } = useColorStore();
  const getEventType = ListEventTypes[eventTypes];
  const eventTypeLabel = EventTypeTags[eventTypes]
    ? t(EventTypeTags[eventTypes])
    : eventTypes.replace(/_/g, ' ');

  if (isEmpty) {
    return (
      <div className="w-full h-[70px] flex items-center justify-center bg-white/10 backdrop-blur-xl border shadow-xl">
        <span className="title1medium text-text-grey dark:text-white/70">
          {t('psc>running>no updates')}
        </span>
      </div>
    );
  }

  const TextContent = () =>
    ambulance ? (
      <div className="flex flex-row items-center gap-3 shrink-0 pr-8">
        <span className="title1medium shrink-0">{t('psc>running>status update')}</span>
        <span className="title1bold shrink-0">{time}</span>
        <span className="title1medium shrink-0">{t('psc>running>ambulance')}</span>
        <span className="title1bold shrink-0">{ambulance.plateNumber}</span>
        <span className="title1medium shrink-0">{t('psc>running>report')}</span>
        <span className="title1bold shrink-0">{idPsc}</span>
        <span
          className="w-fit p-2 rounded-full title2 uppercase text-white shrink-0"
          style={{ backgroundColor: NEWCOLOR[StatusAmbulance[ambulance.ambulanceType].color] }}
        >
          {ambulance.statusLabel}
        </span>
      </div>
    ) : (
      <div className="flex flex-row items-center gap-3 shrink-0 pr-8">
        <span className="title1medium shrink-0">{t('psc>running>status update')}</span>
        <span className="title1bold shrink-0">{time}</span>
        <span className="title1medium shrink-0">{t('psc>running>report')}</span>
        <span className="title1bold shrink-0">{idPsc}</span>
        <span className="title1medium shrink-0">{t('psc>running>is')}</span>
        <span
          className="w-fit p-2 rounded-full title2 uppercase text-white shrink-0"
          style={{ backgroundColor: NEWCOLOR[getEventType.color] }}
        >
          {eventTypeLabel}
        </span>
      </div>
    );

  return (
    <div className="w-full h-[70px] overflow-hidden flex items-center bg-white/10 backdrop-blur-xl border shadow-xl relative">
      <div className="flex w-max m-auto animate-marquee whitespace-nowrap hover:[animation-play-state:paused]">
        <TextContent />
        {/* <TextContent />
        <TextContent />
        <TextContent /> */}
      </div>
    </div>
  );
};

export default RunningText;
